const config = {
  backend_url:
    process.env.NODE_ENV === "production"
      ? "https://api.lokeo.ru/api/"
      : "http://api.lokeo.local/api/"
};
export default config;
